import { MenuItem } from "@shared/interfaces";

import { PERMISSION } from "./permission";
import { NameOfChildRoutes, NamesOfParentRoutes } from "./routes";
import { ReactComponent as Settings } from "../../assets/images/icons/general/settings.svg";
import { ReactComponent as Reports } from "../../assets/images/icons/general/reports.svg";

export const SIDEBAR_MANAGEMENT_ITEMS: MenuItem[] = [
  {
    name: "Dashboard",
    path: `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.DASHBOARD.ROOT}`,
    permission: PERMISSION.VIEW_HOSPITAL_DASHBOARD,
  },
  {
    name: "Patients",
    permission: PERMISSION.VIEW_PATIENTS,
    path: `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.PATIENTS.ROOT}`,
  },
  {
    name: "Users",
    path: `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.USERS.ROOT}`,
    permission: PERMISSION.VIEW_USERS,
  },
  {
    name: "Signal Check",
    permission: PERMISSION.VIEW_SENSOR_DATA_SESSIONS,
    path: `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_SESSIONS.ROOT}`,
  },
  {
    name: "SDH Management",
    path: `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.STATIONS.ROOT}`,
    permission: PERMISSION.VIEW_STATIONS,
  },
  {
    name: "Restore Data",
    path: `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_RESTORING_REQUESTS.ROOT}`,
    permission: PERMISSION.VIEW_SENSOR_DATA_RESTORING_REQUESTS,
  },
];

export const SIDEBAR_FOOTER_MANAGEMENT_ITEMS: MenuItem[] = [
  {
    name: "Reports",
    permission: PERMISSION.GET_FORMS_REPORT,
    path: `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.REPORTS.ROOT}`,
    Icon: Reports,
  },
  {
    name: "Settings",
    permission: PERMISSION.MANAGE_HOSPITALS_SETTINGS,
    path: `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.HOSPITALS.ROOT}`,
    Icon: Settings,
  },
];
